// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"::{'is-negative-charge' : row.entity.adjustment}\" ng-bind=\"::row.entity.adjustment | invEmpty\">\n    </div>\n</div>\n";
// Exports
module.exports = code;